import React from 'react';
import { AddButton } from 'shared/buttons';

const AddMultipleButton = ({ onAdd, disabled }) => (
  <AddButton onClick={onAdd} disabled={disabled} title='Add Multiple' />
);

export default AddMultipleButton;